import { FormLabel, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateUuidComponent,
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import styles from "./component_form_uuid.module.scss";

interface IComponentFormUuidProps {
    component: ITemplateUuidComponent;
    onChange: (component: ITemplateComponent) => void;
    triggerValidate: number;
}

export const ComponentFormUuid: React.FC<IComponentFormUuidProps> = React.memo(({
                                                                                    component,
                                                                                    triggerValidate,
                                                                                    onChange
                                                                                }) => {
    const t = useComponentsTranslations();
    const { validateTag } = useComponentValidateFunction();

    const onFieldChange = (value: Partial<ITemplateUuidComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <div className={styles.description}>{t("uuidComponentDescription")}</div>
        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={validateTag}
                       value={component.name ? component.name : ""}
                       onChange={(e) => onFieldChange({ name: e.target.value })}
                       view="outline"/>
        </FormLabel>
    </div>;
});

